import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { OutOfLivesButtonLayout } from '../../../../layouts/common/OutOfLivesButtonLayout';
import type { AppStateController } from '../../../app/state/AppStateController';
import { formatFixedCountdown } from '../../../utils/time-utils';

export class OutOfLivesButtonView extends Container {
  public readonly onClicked = new Signal();

  private readonly layout = new OutOfLivesButtonLayout();

  constructor(private readonly state: AppStateController) {
    super();
    this.init();
  }

  private init(): void {
    const { root } = this.layout;
    this.addChild(root);

    const interval = setInterval(() => {
      this.updateTimer();
    }, 200);

    root.on('pointerdown', () => {
      this.onClicked.emit();
    });

    this.once('destroyed', () => {
      clearInterval(interval);
      this.onClicked.disconnectAll();
    });
  }

  private updateTimer(): void {
    this.layout.timerText.text = formatFixedCountdown(this.state.getTimeUntilNextLife());
  }
}
